import { Box, TextField } from '@material-ui/core'

const ShortAnswer = ({answer, readonly, answerUpdate}) => {
  return (
    <Box p={1} paddingTop={3}>
      <TextField
        multiline
        rows={5}
        placeholder="Your answer here ..."
        fullWidth
        variant="outlined"
        value={answer}
        onChange={(e) => {
          answerUpdate(e.target.value)
        }}
        InputProps={{
          readOnly: readonly
        }}
      />
    </Box>
  )
}

export default ShortAnswer